/**
 * Analytics Tracking Utility
 * 
 * Tracks business offer analytics events:
 * - view: Offer modal opened
 * - click: Offer bubble clicked
 * - email_request: Offer delivery email requested
 */

import axios from 'axios';
import { API_BASE } from '../config/api';

class AnalyticsTracker {
  /**
   * Track an analytics event
   * @param {string} parkId - The park ID
   * @param {string} eventType - One of: 'view', 'click', 'email_request'
   */
  async track(parkId, eventType) {
    // Validate event type
    const validTypes = ['view', 'click', 'email_request'];
    if (!validTypes.includes(eventType)) {
      console.error(`Invalid analytics event type: ${eventType}`);
      return;
    }

    try {
      await axios.post(
        `${API_BASE}/api/analytics/track`,
        {
          park_id: parkId,
          event_type: eventType
        },
        {
          timeout: 3000 // Short timeout, don't block user experience
        }
      );
      
      // Silent success, don't log to avoid noise
    } catch (error) {
      // Silent failure, analytics should never break user experience
      // Only log in development
      if (process.env.NODE_ENV === 'development') {
        console.debug('Analytics tracking failed:', error.message);
      }
    }
  }

  /**
   * Track offer view (modal opened)
   */
  trackView(parkId) {
    return this.track(parkId, 'view');
  }

  /**
   * Track offer click (bubble clicked)
   */
  trackClick(parkId) {
    return this.track(parkId, 'click');
  }

  /**
   * Track email request
   */
  trackEmailRequest(parkId) {
    return this.track(parkId, 'email_request');
  }
}

// Export singleton instance
const analyticsTracker = new AnalyticsTracker();
export default analyticsTracker;
